import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material";
import MaterialTable from "material-table";
import axios from "axios";
import IssueModal from "./IssueModal";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import IssuePendingDelete from "./IssuePendingDelete";
import IssueRejectDelete from "./IssueRejectDelete";
import IssueResolvedDelete from "./IssueResolvedDelete";
import IssueAcceptDelete from "./IssueAcceptDelete";
import { errorToast } from "../../common/ToastMessage";
import Tooltip from '@mui/material/Tooltip';
import Loader from "../../common/Loader";


function IssueTable(props) {
  const [open, setOpen] = useState(false);
  const [issuesid, setIssuesId] = useState();
  const [openviewmodal, setOpenViewModal] = useState(false);
  const [issuesdata, setIssuesData] = useState("");
  const [disable, setDisable] = useState(false);
  const [applianceData, setApplianceData] = useState([]);
  const [brands, setBrands] = useState([]);
  const [enabledThing, setEnabledThing] = useState(false);
  const [isActive, setLoaderActive] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    getApliances();
    getBrandName();
  }, []);

  const openModal = () => {
    setOpen(true);
  };
  const closeModel = () => {
    setOpen(false);
  };

  const openDeleteModal = (issueDeletId) => {
    setIssuesId(issueDeletId);
    openModal();
  };
  const closeDeleteModal = (id) => {
    setIssuesId(id);
    closeModel();
  };

  const openViewModal = async (id) => {
    setIssuesId(id);
    setLoaderActive(true);
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    await axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Issue/GetByIdIssue?id=${id}`,
        {},
        {
          headers: headers,
        }
      )
      .then(function (response) {
        if (response?.status == "200") {
          setLoaderActive(false)
          setIssuesData(response?.data?.data[0]);
          setOpenViewModal(true);
        }
      })
      .catch(function (error) {
        console.log("error", error);
        setLoaderActive(false);
      });
  };

  const closeViewModal = () => {
    setOpenViewModal(false);
  };

  const getApliances = async () => {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance`,
        {
          headers: headers,
        }
      );
      setApplianceData(response?.data?.data);
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        errorToast(error?.response?.statusText)
      } else {
        errorToast(error?.message)
      }
    }
  };
  const getBrandName = async () => {
    const headers = {
      Authorization: "Bearer " + localStorage.getItem("_token"),
      "Content-type": "application/json",
    };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_PROD}/Api/Appliance/GetBrandName`,
        {
          headers: headers,
        }
      );

      if (response.status === 200) {
        setBrands(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  //close view modal

  const [selectedRow, setSelectedRow] = useState(null);
  const getApplianceCodes = (data) => {
    return data?.applianceCode?.map((item) => {
      return applianceData?.find((ele) => {
        return ele.applianceId == item
      })?.applianceCode || 'N/A'
    })?.join(', ')
  }

  const getBrandNames = (data) => {
    return data?.brandName?.map((item) => {
      return brands?.find((ele) => {
        return ele.brandId == item
      })?.brandName || 'N/A'
    })?.join(', ')
  }

  // Material Table Columns
  const columns = [
    { title: "No.", field: "no" },
    { title: "Employee Name", field: "employeeName" },
    {
      title: "Appliances Code",
      field: "applianceCode",
      render: (rowData) => (
        <>
          <Tooltip title={getApplianceCodes(rowData)}>
            <span>{getApplianceCodes(rowData)}</span>
          </Tooltip>
        </>
      ),
    },
    {
      title: "Brand",
      field: "brandName",
      render: (rowData) => (
        <>
          <Tooltip title={getBrandNames(rowData)}>
            <span>{getBrandNames(rowData)}</span>
          </Tooltip>
        </>
      ),
    },
    {
      title: "Date",
      field: "date",
      render: (rowData) => {
        return moment(rowData?.date).format("DD/MM/YYYY");
      },
    },
    { title: "Assigned Project Name", field: "assignProjectName" },
    { title: "Issue Description", field: "issueDescription" },

    {
      title: "Status",
      field: "action",

      render: (rowData) => (
        <span>
          {props.isCalledFrom === "pending" ? (
            <>
              <Link
                href="#"
                className="edit me-3 "
                title="View"
                onClick={() => {
                  openViewModal(rowData?.issueId);
                  setDisable(false);
                }}
              >
                <VisibilityIcon color="primary" />
              </Link>
            </>
          ) : props.isCalledFrom === "accept" ? (
            <Link href="#" className="edit me-3 " title="accept">
              <VerifiedOutlinedIcon color="primary" />
            </Link>
          ) : props.isCalledFrom === "resolved" ? (
            <Link href="#" className="edit me-3 " title="resolved">
              <TaskAltOutlinedIcon color="success" />
            </Link>
          ) : props.isCalledFrom === "rejected" ? (
            <Link href="#" className="edit me-3 " title="rejected">
              <CancelOutlinedIcon color="error" />
            </Link>
          ) : null}
        </span>
      ),
    },
  ];
  const getColums = (cols) => {
    if (props.isCalledFrom === "accept") {
      cols?.splice(7, 0, { title: "Accepted Reason", field: "adminResponse" })
      return cols
    } else if (props.isCalledFrom === "rejected") {
      cols?.splice(7, 0, { title: "Rejected Reason", field: "adminResponse" })
      return cols
    } else {
      return cols
    }
  }
  const defaultMaterialTheme = createTheme();
  return (
    <>
      <Loader isLoading={isActive} />
    <div className="issue">
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={props?.title}
          options={{
            selection: true,
            rowStyle: (rowData) => ({
              backgroundColor:
                selectedRow === rowData?.tableData?.id ? "#F3F5F5" : "#FFF",
            }),
            headerStyle: {
              backgroundColor: "#E5F0FB",
            },
          }}
          onRowClick={(evt, selectedRow) =>
            setSelectedRow(selectedRow?.tableData?.id)
          }
          actions={[
            {
              tooltip: "Remove All Selected Users",
              icon: "delete",
              onClick: (evt, data) => {

                let selectedUserData = [];
                data?.map((dat) => selectedUserData.push(dat?.issueId));
                openDeleteModal(selectedUserData);
              },
            },
          ]}
          columns={getColums(columns)}
          data={props.issue}
        />
      </ThemeProvider>

      {open && props.isCalledFrom === "pending" && (
        <IssuePendingDelete
          open={open}
          close={closeDeleteModal}
          issueDeletId={issuesid}
          getIssue={props.getissueDetails}
        />
      )}

      {open && props.isCalledFrom === "accept" && (
        <IssueAcceptDelete
          open={open}
          close={closeDeleteModal}
          issueDeletId={issuesid}
          getAcceptDetails={props.getAcceptDetails}
        />
      )}

      {open && props.isCalledFrom === "resolved" && (
        <IssueResolvedDelete
          open={open}
          close={closeDeleteModal}
          issueDeletId={issuesid}
          getResolvedIssue={props.getResolved}
        />
      )}

      {open && props.isCalledFrom === "rejected" && (
        <IssueRejectDelete
          open={open}
          close={closeDeleteModal}
          issueDeletId={issuesid}
          getRejectedIssue={props.getRejected}
        />
      )}
      {openviewmodal && (
        <IssueModal
          issueacceptid={issuesid}
          viewissuedata={issuesdata}
          open={openviewmodal}
          close={closeViewModal}
          disableField={disable}
          getissueDetails={props.getissueDetails}
          getAcceptDetails={props.getAcceptDetails}
          getRejectedIssue={props.getRejected}
        />
      )}
    </div>
    </>
  );
}

export default IssueTable;
